import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider, useSelector } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ConfigProvider, message } from 'antd';
import { ToastContainer } from 'react-toastify';
import arEG from 'antd/locale/ar_EG';
import enUS from 'antd/locale/en_US';
import 'react-toastify/dist/ReactToastify.css';

import App from './App';
import { store } from '@store/index';
import antdTheme from './antd-theme';
import './i18n'; // Initialize i18n
import './index.css';

// Wrapper component to access Redux state
const AppWrapper = () => {
  const { current: language, direction } = useSelector((state) => state.language);
  const locale = language === 'ar' ? arEG : enUS;
  const isRTL = direction === 'rtl';

  // Ensure document direction is always in sync
  React.useEffect(() => {
    document.documentElement.dir = direction;
    document.documentElement.lang = language;
  }, [direction, language]);

  // Configure Ant Design message component for RTL
  React.useEffect(() => {
    message.config({
      top: 24,
      duration: 3,
      maxCount: 3,
      rtl: isRTL,
      prefixCls: 'ant-message',
    });
  }, [isRTL]);

  return (
    <ConfigProvider theme={antdTheme} locale={locale} direction={direction}>
      <App />
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={isRTL}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </ConfigProvider>
  );
};

ReactDOM.createRoot(document.getElementById('root')).render(
  // <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <AppWrapper />
      </BrowserRouter>
    </Provider>
  // </React.StrictMode>
);
